export const colorsMapRgb = {
  '2xx': '98, 212, 147',
  '3xx': '218, 245, 230',
  '4xx': '255, 110, 51',
  '5xx': '224, 45, 0',
  hooks: '161, 196, 251',
  errors: '217, 63, 0',
  bundle: '204, 204, 204',
  console: '255, 208, 101',
};

export const colorsMap = {
  ...colorsMapRgb,
  paused_users: '117, 116,117',
  paused_zaps: '117, 116,117',
  live_users: '98, 212, 147',
  live_zaps: '98, 212, 147',
};
